module.exports = __webpack_public_path__ + "static/media/img03.af3d1d61.png";